// src/components/Header.js
import React from 'react';
import unvLogo from './UNV-Logo.png';

const Header = ({ isAuthenticated, showLogout, onLogout }) => (
  <div className="header-container">
    <img src={unvLogo} alt="UNV Logo" className="header-logo" />
    <h1 className="app-title">UN Volunteers Open API Service</h1>

    <div className="header-actions">
      {showLogout && (
        <button onClick={onLogout} className="logout-button">
          Log Out
        </button>
      )}
    </div>
  </div>
);

export default Header;